import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function TimePhaseReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_TIME_PHASE: {
			let timePhases = action.response;
			return timePhases;
		}
		case types.UPDATE_TASK_TIME_PHASES: {
			return state;
		}
		default:
			return state;
	}
}
